import { createStore, combineReducers, applyMiddleware } from "redux"
import { setStore } from "./getStore"
import thunk from "redux-thunk"
import depannageReducer from "./reducers/depannageReducer"
import setNav from "./reducers/navReducer"
import depSearchReducer from "./reducers/depSearchReducer"
import parcReducer from "./reducers/parcReducer"
import inventaireReducer from "./reducers/inventaireReducer"
import atelierReducer from "./reducers/atelierReducer"
import emailReducer from "./reducers/emailReducer"
import atelierSearchReducer from "./reducers/atelierSearchReducer"
import autreReducer from "./reducers/autreReducer"
import masterReducer from "./reducers/masterReducer"
import atelierModeleReducer from "./reducers/atelierModeleReducer"
import locationReducer from "./reducers/locationReducer"
import locationSearchReducer from "./reducers/locationSearchReducer"
import locationGererReducer from "./reducers/locationGererReducer"
import atelierInventaireReducer from "./reducers/atelierInventaireReducer"
import entretienReducer from "./reducers/entretienReducer"
import atelierExtrasReducer from "./reducers/atelierExtrasReducer"
import statsV2Reducer from "./reducers/statsV2Reducer"
import clientsReducer from "./reducers/clientsReducer"
import depannageDispatchReducer from "./reducers/depannageDispatchReducer"
import adressesReducer from "./reducers/adresseReducer"
import ficheOuverteReducer from "./reducers/ficheOuverteReducer"
import informationReducer from "./reducers/informationReducer"
import accessReducer from "./reducers/accessReducer"
import notificationEligibiliteReducer from "./reducers/notificationEligibiliteReducer"
import errorReportReducer from "./reducers/errorReportReducer"
import entiteReducer from "./reducers/entiteReducer"
import facturationReducer from "./reducers/facturationReducer"
import encaissementsV2Reducer from "./reducers/encaissementsV2Reducer"
import pointInteretReducer from "./reducers/pointInteretReducer"
import heureReducer from "./reducers/heureReducer"
import agendaReducer from "./reducers/agendaReducer"
import toastReducer from "./reducers/toastReducer"
import notificationReducer from "./reducers/notificationReducer"
import diagnostiqueReducer from "./reducers/diagnostiqueReducer"
import policeTarifsReducer from "./reducers/policeTarifsReducer"
import feriesReducer from "./reducers/feriesReducer"
import feuilletageReducer from "./reducers/feuilletageReducer"
import patchnotesReducer from "./reducers/patchnotesReducer"
import rapprochementReducer from "./reducers/rapprochementReducer"

const rootReducer = combineReducers({
	navInfo: setNav,
	parcInfo: parcReducer,
	depInfo: depannageReducer,
	depSearchInfo: depSearchReducer,
	inventaire: inventaireReducer,
	atelierInventaire: atelierInventaireReducer,
	atelierInfo: atelierReducer,
	emailInfo: emailReducer,
	atelierSearchInfo: atelierSearchReducer,
	autreInfo: autreReducer,
	masterReducer: masterReducer,
	toastReducer: toastReducer,
	atelierModeleInfo: atelierModeleReducer,
	locationInfo: locationReducer,
	locationSearchInfo: locationSearchReducer,
	locationGererInfo: locationGererReducer,
	entretienInfo: entretienReducer,
	atelierExtrasInfo: atelierExtrasReducer,
	statsV2Info: statsV2Reducer,
	clientsInfo: clientsReducer,
	depannageDispatchInfo: depannageDispatchReducer,
	adressesInfo: adressesReducer,
	fichesOuvertesInfo: ficheOuverteReducer,
	informationsInfo: informationReducer,
	accessInfo: accessReducer,
	notifEligibiliteInfo: notificationEligibiliteReducer,
	errorReportsInfo: errorReportReducer,
	entiteInfo: entiteReducer,
	facturationInfo: facturationReducer,
	encaissementsV2Info: encaissementsV2Reducer,
	pointInteretInfo: pointInteretReducer,
	heureInfo: heureReducer,
	agendaInfo: agendaReducer,
	notificationInfo: notificationReducer,
	diagnostiqueInfo: diagnostiqueReducer,
	policeTarifsInfo: policeTarifsReducer,
	feriesInfo: feriesReducer,
	feuilletageInfo: feuilletageReducer,
	patchnotesInfo: patchnotesReducer,
	rapprochementInfo: rapprochementReducer,
})

const store = createStore(rootReducer, applyMiddleware(thunk))
setStore(store)

export default store
